import useTranslation from 'next-translate/useTranslation';
import { Title } from '../Title';
import { ContactForm } from './Form';

function ContactStorage() {
  const { t } = useTranslation();

  return (
    <div className='space-y-6'>
      <Title title={t('services:Contact.title')} />
      <ContactForm />
    </div>
  );
}

export default ContactStorage;
